<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useCurriculumStore } from '@/store/curriculum';
import { useLocale } from '@/plugins/translation';
import type { Category } from '@ilteducation/curriculum-types';

const curriculumStore = useCurriculumStore();

const { curriculum } = storeToRefs(curriculumStore);

const { t, l } = useLocale();

const combinedCategory = (category?: Category, res?: Category): Category | undefined => {
  if (!category) {
    return undefined;
  }
  const mergeTitles = (title1: Category['title'], title2: Category['title']): Category['title'] => {
    const combinedTitle: Category['title'] = {};
    Object.keys(title1).forEach((language) => {
      combinedTitle[language] = `${title1[language]} | ${title2[language]}`;
    });
    return combinedTitle;
  };
  const title = res ? mergeTitles(res.title, category.title) : category.title;
  const currentCategory: Category = { title };
  if (category && category.child) {
    return combinedCategory(category.child, currentCategory);
  }
  return currentCategory;
};
</script>

<template>
  <div class="curriculum-container">
    <div v-for="(curriculumItem, index) in curriculum" :key="index">
      <h3>{{ t('curriculum.curriculum_title_1') }}{{ curriculumItem.code }}{{ t(l.curriculum.curriculum_title_2) }}</h3>

      <div v-for="(grade, gradeIndex) in curriculumItem.grades" :key="gradeIndex">
        <h4 class="grade">
          {{ t('curriculum.grade_prefix') }}{{ curriculumItem.defaultLanguage !== 'nob' ? grade : `${grade}. trinn` }}
        </h4>

        <ul v-for="(goal, goalIndex) in curriculumItem.goals" :key="goalIndex" class="goal-list">
          <li v-if="goal.grade == grade" class="curriculum-goal">
            <b v-if="curriculumItem.defaultLanguage === 'fi'"
              >{{ combinedCategory(goal.category)?.title[curriculumItem.defaultLanguage] }}:
            </b>
            {{ goal.content[curriculumItem.defaultLanguage] }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.curriculum-container {
  h5 {
    margin: 20px 0 4px;
  }
  ul {
    padding-left: 24px;
  }
  li {
    padding: 6px 0;
    line-height: 20px;
  }
}
</style>
